import Component from '../inherited/Component';

export default class Wishcraft extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
  }

  mount() {
    const intradaWishlistCallback = async () => {
        const targetNodes = document.querySelectorAll('.intrada-wishlist');
        const config = { attributes: true, childList: true, subtree: true };

        function replaceText(el) {
            let paragraphs = el.querySelectorAll('.intrada-wishlist--popup-inner p')
            let inputs = el.querySelectorAll('.intrada-wishlist--popup-inner input')
            let buttons = el.querySelectorAll('.intrada-wishlist--popup-inner button')
            let all = [...paragraphs, ...inputs, ...buttons];
            for(let el of all) {
                if(el.textContent.toLowerCase().includes('wishlist') || el.textContent.toLowerCase().includes('list')) {
                    if(el.classList.contains('intrada-wishlist--popup-login-prompt')) {
                      el.innerHTML = el.innerHTML.replaceAll('wishlist', 'project')
                    } else {
                      el.textContent = el.textContent.replaceAll('wishlist', 'project').replaceAll('List', 'Project').replaceAll('list', 'project')
                    }
                }
                if(el.placeholder && (el.placeholder.toLowerCase().includes('wishlist') || el.placeholder.toLowerCase().includes('list'))) {
                    el.placeholder = el.placeholder.replaceAll('wishlist', 'project').replaceAll('List', 'Project').replaceAll('list', 'project')
                }
            }
          }
        
        for(let targetNode of targetNodes) {
            let callback = function (mutationsList, observer) {
                replaceText(targetNode)
            };

            let observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
      }
      if (window.INTRADA_WISHLIST) {
        radiantWishlistCallback()
      } else {
        document.addEventListener('INTRADA_WISHLIST_READY', intradaWishlistCallback )
      }
  }
}
